import React from "react";
import "./PGAModelBuilderButton.css";
import { TailSpin } from "react-loader-spinner";

export default function PGAModelBuilderButton(props) {
  if (props.modelBuilding) {
    return (
      <div
        className="pga-model-builder-button-pending"
        style={{ ...props.style }}
      >
        <TailSpin
          height="30"
          width="30"
          color="white"
          ariaLabel="tail-spin-loading"
          radius="1"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <button className="pga-model-builder-button" {...props}>
      {props.children}
    </button>
  );
}
